// Light By Blayne — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // Update cart count in nav
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector('.js-cart-count');
        if (el) el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
      });
  }
  updateCartCount();

  // Mobile nav toggle
  const navToggle = document.querySelector('.js-nav-toggle');
  const navDrawer = document.querySelector('.js-nav-drawer');
  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', () => {
      navDrawer.classList.toggle('is-open');
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Add to cart form handling — adds item, then takes the shopper to the cart
  const atcForms = document.querySelectorAll('.js-atc-form');
  atcForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.js-atc-btn');
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      const originalLabel = btn ? btn.textContent : '';

      if (btn) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(() => {
        updateCartCount();
        if (btn) btn.textContent = 'Added ✓';
        window.location.href = '/cart';
      })
      .catch(() => {
        if (btn) { btn.textContent = originalLabel; btn.disabled = false; }
      });
    });
  });

});
